<template>
<div>
  <modal-view-boleto ref="modal_view_boleto" />
  <b-modal
      id="modalBoleto"
      ref="modalBoleto"
      title="Boletos"
      @hide="resetModal"
      size="xl"
      centered
      scrollable
  >
    <!-- Overlay que mostra o spinner enquanto a requisição está em andamento -->
    <b-overlay
        :show="$store.state.BoletoStore.setIsLoadingBoleto"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
    >
      <!-- Exibe o alerta se não houver boletos -->
      <b-alert
          v-if="!$store.state.BoletoStore.setIsLoadingBoleto && $store.state.BoletoStore.boletos.length === 0"
          variant="warning"
          show
      >
        <div class="alert-body">
          <span><strong>{{ $store.state.BoletoStore.message }}</strong></span>
        </div>
      </b-alert>

      <!-- Exibe a tabela se houver boletos -->
      <b-table
          v-show="!$store.state.BoletoStore.setIsLoadingBoleto && $store.state.BoletoStore.boletos.length > 0"
          ref="tableBoleto"
          :striped="true"
          :bordered="true"
          :hover="true"
          :responsive="true"
          table-variant="secondary"
          :items="$store.state.BoletoStore.boletos"
          :fields="fields"
          small
      >
        <template #cell(view)="data">
          <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              @click="viewBoletos(data.item)"
          >
            <feather-icon
                icon="SearchIcon"
                class="mr-50"
                size="16"
            />
            <span class="align-middle">Ver</span>
          </b-button>
        </template>
      </b-table>
    </b-overlay>
  </b-modal>
</div>
</template>

<script>
import {
  BModal, BCard, BCardHeader, BCardBody, BTable, BButton,
} from 'bootstrap-vue';
import { mapActions } from 'vuex';
import ModalViewBoleto from '@/views/app/operacoes/pedidosVendas/modal/modalViewBoleto.vue';

export default {
  name: 'modalBoleto',
  components: {
    ModalViewBoleto,
    BModal,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
  },

  data() {
    return {
      fields: [
        { key: 'estabelecimentoid', label: 'Estabelecimento' },
        { key: 'banco_nome', label: 'Banco' },
        { key: 'titulonumero', label: 'Número título' },
        { key: 'titulodocumento', label: 'Documento' },
        { key: 'tituloparcela', label: 'Parcela' },
        { key: 'titulodtemissao', label: 'Data Emissão' },
        { key: 'titulovalororiginal', label: 'Valor Original' },
        { key: 'tituloDtVencimento', label: 'Data Vencimento' },
        { key: 'titulodtliquidacao', label: 'Data Liquidação' },
        { key: 'titulosituacao', label: 'Situação' },
        { key: 'clienterazaosocial', label: 'Razão Social' },
        { key: 'view', label: 'Visualizar' },
      ],
    };
  },
  methods: {
    ...mapActions('BoletoStore', ['getBoletos', 'generateBoleto']),
    async showModalBoleto(data) {
      this.$store.commit('BoletoStore/SET_QUERY', {
        clienteid: data.clienteId,
        pedidoid: data.pedidoId,
      });
      await this.$bvModal.show('modalBoleto');
      this.getBoletosList();
    },

    async resetModal() {
      this.$store.commit('BoletoStore/SET_QUERY', {
        clienteid: null,
        pedidoid: null,
      });
      this.$store.commit('BoletoStore/SET_BOLETOS', []);
      this.$store.commit('BoletoStore/SET_MESSAGE', '');
    },
    async getBoletosList() {
      await this.getBoletos();
    },
    async viewBoletos(data) {
      await this.generateBoleto(data);
      this.$refs.modal_view_boleto.showModalViewBoleto();
    },
  },
};
</script>

<style scoped>
/* Adicione estilos se necessário */
</style>
